"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightListFilter = exports.flightListFilterConfig = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Button_1 = require("../../../Button");
const Multiple_1 = require("../../../CheckBox/Multiple");
const Field_1 = require("../../../Form/Field");
const stable_1 = require("../../../Form/Field/DateRange/stable");
const Select_1 = require("../../../Form/Field/Select");
const utils_1 = require("../../../Form/Field/Select/utils");
const Weekdays_1 = require("../../../Form/Field/Weekdays");
const messages_1 = require("../messages");
const SequenceFilter_1 = require("./SequenceFilter");
const utils_2 = require("./utils");
require("./index.scss");
exports.className = 'flight-list-filter';
const flightListFilterConfig = (data) => {
    var _a;
    return ({
        type: 'object',
        shape: {
            query: {
                type: 'string',
                optional: true,
                modificators: 'search',
            },
            isActiveOnly: {
                type: 'boolean',
                optional: true,
            },
            statuses: {
                type: 'array',
                optional: true,
                items: [
                    'created',
                    'departed',
                    'cancelled',
                ],
            },
            departure: {
                type: 'object',
                optional: true,
                modificators: 'together',
                dateRestrictions: {
                    pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                    nextYearsCount: dateTime_1.bookingNextYearsCount,
                },
                shape: {
                    from: {
                        type: 'date',
                        optional: true,
                    },
                    to: {
                        type: 'date',
                        optional: true,
                        dateRestrictions: {
                            notAllowedBeforeDate: (_a = data === null || data === void 0 ? void 0 : data.departure) === null || _a === void 0 ? void 0 : _a.from,
                        },
                    },
                },
            },
            origin: {
                type: 'object',
                optional: true,
            },
            destination: {
                type: 'object',
                optional: true,
            },
            weekdays: {
                type: 'array',
                optional: true,
            },
            sequence: {
                type: 'number',
                optional: true,
                hidden: (data === null || data === void 0 ? void 0 : data.sequence) === undefined,
            },
        },
    });
};
exports.flightListFilterConfig = flightListFilterConfig;
const FlightListFilter = (props) => {
    const { field, cancelledCount, submit, reset, } = props;
    const { locale, formatMessage } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: `${exports.className}__form` },
            react_1.default.createElement(Field_1.FormFieldStable, { ...field(['query']), placeholder: formatMessage(messages_1.messages.searchPlaceholder), prefixIcon: 'search', additionClassNames: `${exports.className}__search` }),
            react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:SearchButton', defaultMessage: 'Search' }), modificators: ['ascetic', 'block'], onClick: submit, additionClassNames: `${exports.className}__button` }),
            react_1.default.createElement("div", { className: `${exports.className}__checkboxes` },
                react_1.default.createElement(Multiple_1.CheckBoxMultiple, { ...field(['statuses']), title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:Status', defaultMessage: 'Status:' }), toItem: (0, utils_2.mapFlightStatusToItem)(cancelledCount) })),
            react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:ResetButton', defaultMessage: 'Reset' }), onClick: reset, modificators: 'simple', additionClassNames: `${exports.className}__reset` })),
        react_1.default.createElement("div", { className: `${exports.className}__form ${exports.className}__form--fields` },
            react_1.default.createElement(stable_1.FormFieldDateRangeStable, { ...field(['departure']), additionClassNames: `${exports.className}__dates`, fromField: {
                    ...field(['departure', 'from']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:DepartureFrom', defaultMessage: 'Departure from' })),
                }, toField: {
                    ...field(['departure', 'to']),
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:DepartureTo', defaultMessage: 'Departure to' })),
                } }),
            react_1.default.createElement("div", { className: `${exports.className}__airports` },
                react_1.default.createElement("div", { className: 'form-fields-together' },
                    react_1.default.createElement(Select_1.FormFieldSelect, { ...field(['origin']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:Origin', defaultMessage: 'Origin' }), toItem: (0, utils_1.mapAirportToSelectItem)(locale) }),
                    react_1.default.createElement(Select_1.FormFieldSelect, { ...field(['destination']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List:Destination', defaultMessage: 'Destination' }), toItem: (0, utils_1.mapAirportToSelectItem)(locale) }))),
            react_1.default.createElement(Weekdays_1.FormFieldWeekdays, { ...field(['weekdays']), additionClassNames: `${exports.className}__weekdays` })),
        react_1.default.createElement(SequenceFilter_1.SequenceFilter, { ...field(['sequence']) })));
};
exports.FlightListFilter = FlightListFilter;
//# sourceMappingURL=index.js.map